import { SxProps, Theme } from '@mui/material';
import { aiGradientTextSx } from 'common/constants/ai/aiGradient';

export const toolbarContainerSx: SxProps<Theme> = {
  display: 'flex',
  gap: 1,
  alignItems: 'center',
  my: 0.5,
};

/** Tight split control: no gap between label button and chevron (MUI buttons default to 8px sibling margin in some themes). */
export const createLabelsSplitGroupSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  gap: 0,
  '& > .MuiButton-root': { margin: 0 },
};

export const dropdownChevronButtonSx: SxProps<Theme> = {
  p: 0,
  pl: 0,
  pr: 0.25,
  minWidth: 0,
  width: 'auto',
  '& .MuiButton-endIcon': { marginLeft: 0 },
};

export const createLabelsButtonSx: SxProps<Theme> = {
  textTransform: 'none',
  whiteSpace: 'nowrap',
  border: 'none',
  py: 0.25,
  px: 1,
  minHeight: 0,
  lineHeight: 1.2,
  fontSize: '0.75rem',
  '&:hover': {
    border: 'none',
    backgroundColor: 'transparent',
  },
};

/** Primary half of split control: flush against chevron button. */
export const createLabelsPrimarySplitButtonSx: SxProps<Theme> = {
  ...createLabelsButtonSx,
  pr: 0,
};

export const pushMappingsButtonSx: SxProps<Theme> = {
  textTransform: 'none',
  whiteSpace: 'nowrap',
  py: 0.25,
  px: 1.5,
  minHeight: 0,
  lineHeight: 1.2,
  fontSize: '0.75rem',
};

export const aiIconSx: SxProps<Theme> = {
  width: 16,
  height: 16,
  marginRight: 0.5,
  marginTop: '4px',
};

export const menuItemAiIconSx: SxProps<Theme> = {
  width: 14,
  height: 14,
  marginRight: 1,
};

export const aiMenuItemTextSx: SxProps<Theme> = {
  ...(aiGradientTextSx as Record<string, unknown>),
  fontWeight: 500,
};

export const createLabelsTextSx: SxProps<Theme> = {
  ...(aiGradientTextSx as Record<string, unknown>),
  fontWeight: 600,
};

export const popperSx: SxProps<Theme> = {
  zIndex: 1,
};
